
export class PaymentSummaryResponse {
  error: boolean;
  message: string;
  packageEntryResult: PackageEntryResult;
  addOnEntryResult: AddOnEntryResult;
  billingTotal: string;
  totalTax: number;
}

class BaseOrderEntryResult {
  error: boolean;
  message: string;
  price : string;
  tax : string;
  total : string;
  priceNum : number;
  taxNum : number;
  totalNum : number;
}

export class PackageEntryResult extends BaseOrderEntryResult {
  packageName: string;
}


export class AddOnEntryResult extends BaseOrderEntryResult {
  productEntryResults: ProductEntryResult[];
}


export class ProductEntryResult extends BaseOrderEntryResult
{
    productName: string;
}
